import { BEARER_TOKEN } from 'src/dataLayer/env';
import { getTrackingUUID } from 'src/dataLayer/localData/cookies';

export default () => ({
  Authorization: `Bearer ${BEARER_TOKEN}`,
  'Content-Type': 'application/json',
  'X-Babbel-Tracking-UUID': getTrackingUUID()
});
